

const Contact = () =>{
    return(
        <div class="container my-5">

<div class="row contact">
					<div class="col-12">
						<div class="subscription-form">

							<form action="#" class="row">
								<div class="col-6">
                                    <label class="text-dark">First  Name</label>
									<input type="text" class="form-control"/>
								</div>
								<div class="col-6">
                                <label class="text-dark">Last  Name</label>
									<input type="email" class="form-control"/>
								</div>
                                <div class="col-12">
                                <label class="text-dark">Email  Address</label>
									<input type="email" class="form-control"/>
								</div>
                                <div class="col-12">
                                <label class="text-dark ">Message</label>
									<textarea type="email" class="form-control txt h-100"/>
								</div>
                                <button type="submit" class="btn btn-primary-hover-outline">Send Message</button>
							</form>

						</div>
					</div>
				</div>


                
        </div>
    )
}

export default Contact;